import { load } from 'recaptcha-v3';

let FORM_SELECTOR = '.page-container form';
const RECPATCHA_FIELD = 'recpatchaSiteKey';

export const displayResponse = function (data) {
    const alertSuccess = document.querySelector('.page-container form .alert-success') as HTMLElement;
    const alertError = document.querySelector('.page-container form .alert-danger') as HTMLElement;

    alertSuccess.classList.add('hidden');
    alertError.classList.add('hidden');

    if (data.success) alertSuccess.classList.remove('hidden');
    else {
        let errorMessage = '';
        data.errors.forEach(error => {
            errorMessage += `<p>* ${error}</p>`;
            alertError.innerHTML = errorMessage;
        });
        alertError.classList.remove('hidden');
    }
};

export const recaptchaFunction = async function () {
    const recaptchaId = (document.getElementById(RECPATCHA_FIELD) as HTMLInputElement).value;
    const recaptcha = await load(recaptchaId);
    const token = await recaptcha.execute('submit');

    let result = await fetch("/api/recaptcha", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: token })
    }).then(r => { return r.json(); });

    return result;
};
